import {QueryMetricCountFieldId} from '../project-query-metric-source.ts';
import type {AppSurfaceDefinitionVersion} from './spec.ts';
/** Native profile only. This describes supported shapes, never authority or an aggregate value. */
export function isNativeCountDashboard(d:AppSurfaceDefinitionVersion):boolean{
 if(d.type!=='DASHBOARD'||!d.blueprintManifestRef||!d.scope.projectId||d.refreshPolicy.mode!=='MANUAL'||d.actions.length||!d.widgets.some(w=>w.type==='METRIC'))return false;
 return d.dataSources.every(source=>{
  const widgets=d.widgets.filter(w=>w.sourceId===source.id);if(!widgets.length)return false;
  if(source.kind==='PROJECT_QUERY')return widgets.every(w=>w.type==='TABLE'||w.type==='STATUS_LIST');
  return source.kind==='READ_MODEL'&&source.maxRows===1&&source.fieldIds.length===1&&source.fieldIds[0]===QueryMetricCountFieldId&&widgets.every(w=>w.type==='METRIC');
 })&&d.widgets.every(w=>d.dataSources.some(s=>s.id===w.sourceId))&&new Set(d.dataSources.map(s=>s.id)).size===d.dataSources.length;
}
